import { BsPencilFill } from "react-icons/bs";
import { RiDeleteBin6Fill } from "react-icons/ri";
import Toggle from 'react-toggle';
import CustomInput from "../../components/custom-input";
import { useAppState } from "../../providers/app-state";
import skgIcon from './SG_hex.svg'
import postal from "../../services/postal";
import { useHttp } from '../../providers/http'
import "react-toggle/style.css"
import { useCallback, useEffect, useMemo, useState } from "react";
import {
    info_step_city_field_placeholder,
    info_step_city_field_title,
    info_step_comment_field_placeholder,
    info_step_comment_field_title,
    info_step_countrycode_field_placeholder,
    info_step_countrycode_field_title,
    info_step_description,
    info_step_email_field_placeholder,
    info_step_email_field_title,
    info_step_heading,
    info_step_name_field_placeholder,
    info_step_name_field_title,
    info_step_newsletter_desc,
    info_step_newsletter_title,
    info_step_odometer_field_placeholder,
    info_step_odometer_field_title,
    info_step_phone_field_placeholder,
    info_step_phone_field_title,
    info_step_plate_field_placeholder,
    info_step_plate_field_title,
    info_step_postal_field_placeholder,
    info_step_postal_field_title
} from '../../lang/da';
import Skeleton from "react-loading-skeleton";
import ConsentInfoBlock from "../../components/consent-info-block";

//used to debounce input. no reason to send requests while user is still actively typing.
const debounce = (fn, wait) => {
    let timer;
    return (...args) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            fn(...args)
        }, wait)
    }
}

const InfoScreen = ({ goToByStepTitle, pathname, scrollTo }) => {
    const { state, dispatch, dispatchMultiple } = useAppState();
    const http = useHttp()
    const [loadingCar, setLoadingCar] = useState(false);

    const [coupon, setCoupon] = useState("");
    const [couponValid, setCouponValid] = useState(true);

    const isExistingOffer = useMemo(() => {
        return pathname.match(/existingoffer/i);
    }, [pathname])

    const validateCoupon = useCallback(async () => {
        return http.get("/bookings/coupon/" + coupon)
    }, [coupon])

    const fetchCar = useCallback(debounce(plate => {
        if (String(plate).length < 3) {
            return dispatchMultiple([
                {
                    key: "carType",
                    value: ""
                },
                {
                    key: "carYear",
                    value: ""
                },
                {
                    key: "carColor",
                    value: ""
                },
                {
                    key: "carMake",
                    value: ""
                },
                {
                    key: "carModel",
                    value: ""
                },
            ])
        }

        setLoadingCar(true);
        http.get("/cars/lookup/da/plate/" + plate)
            .then(({ data }) => {
                const {
                    vehicle: {
                        body_type,
                        model_year,
                        color,
                        make,
                        model
                    }
                } = data;

                dispatchMultiple([
                    {
                        key: "carType",
                        value: body_type
                    },
                    {
                        key: "carYear",
                        value: model_year
                    },
                    {
                        key: "carColor",
                        value: color
                    },
                    {
                        key: "carMake",
                        value: make
                    },
                    {
                        key: "carModel",
                        value: model
                    },
                    {
                        key: "plate",
                        value: {
                            value: plate,
                            valid: true
                        }
                    }
                ])
            })
            .catch(err => {
                dispatchMultiple([
                    {
                        key: "carType",
                        value: ""
                    },
                    {
                        key: "carYear",
                        value: ""
                    },
                    {
                        key: "carColor",
                        value: ""
                    },
                    {
                        key: "carMake",
                        value: ""
                    },
                    {
                        key: "carModel",
                        value: ""
                    },
                    {
                        key: "plate",
                        value: {
                            value: plate,
                            valid: false
                        }
                    }
                ])
            })
            .finally(() => {
                setLoadingCar(false)
            })
    }, 1000), [])

    useEffect(() => {
        if (state.plate.value) {
            fetchCar(state.plate.value)
        }
    }, [fetchCar])

    return (
        <div
            className="flex flex-wrap space-y-9 py-20"
        >
            <div
                className="basis-full"
            >
                <div
                    className="max-w-3xl space-y-4"
                >
                    <div>
                        <p>
                            {`Afslut ${(String(pathname).match(/booking/i) || isExistingOffer) ? "booking" : "tilbud"}`}
                        </p>
                        <p
                            className="text-3xl"
                        >
                            {
                                info_step_heading
                            }
                        </p>
                    </div>
                    <p
                        className="text-sm font-light"
                    >
                        {
                            info_step_description
                        }
                    </p>
                </div>
            </div>
            <div
                className="basis-full lg:basis-2/5 space-y-5"
            >
                <label
                    className="flex items-center space-x-3"
                >
                    <span
                        className="text-xs"
                    >Virksomhed</span>
                    <Toggle
                        className="bg-skgBlue"
                        icons={false}
                        value={state.company ? "yes" : "no"}
                        onChange={e => dispatch({
                            key: "company",
                            value: e.target.checked
                        })}
                    />
                </label>
                {
                    state.company && (
                        <>
                            <CustomInput
                                placeholder="148902348"
                                labelText="Firma Cvr nr."
                                value={state.cvr}
                                scrollTo={scrollTo}
                                onChange={e => {
                                    dispatch({
                                        key: "cvr",
                                        value: e.target.value
                                    })
                                }}
                            />
                            <hr
                                className="border-skgGray"
                            />
                        </>
                    )
                }
                <div
                    className="flex row space-x-5"
                >
                    <CustomInput
                        labelText={info_step_plate_field_title}
                        placeholder={info_step_plate_field_placeholder}
                        value={state.plate.value}
                        valid={((!state.plate.value.length > 2 || state.plate.valid))}
                        errorMessage="Vi kan ikke finde bilen (Send uden plade hvis den ikke findes)"
                        scrollTo={scrollTo}
                        onChange={e => {
                            if (e.target.value.length >= 8) return;

                            fetchCar(e.target.value);
                            dispatch({
                                key: "plate",
                                value: {
                                    value: e.target.value,
                                    valid: e.target.value.length < 3 ? false : state.plate.valid
                                }
                            })
                        }}
                    />
                    <CustomInput
                        labelText={info_step_odometer_field_title}
                        placeholder={info_step_odometer_field_placeholder}
                        value={state.mileage}
                        scrollTo={scrollTo}
                        onChange={e => dispatch({
                            key: "mileage",
                            value: e.target.value
                        })}
                    />
                </div>
                <hr
                    className="border-skgGray"
                />
                <CustomInput
                    labelText={info_step_name_field_title}
                    placeholder={info_step_name_field_placeholder}
                    value={state.name.value}
                    valid={state.name.valid}
                    errorMessage="Navn er for kort"
                    onChange={e => dispatch({
                        key: "name",
                        value: {
                            valid: e.target.value.length > 1,
                            value: e.target.value
                        }
                    })}
                />
                <CustomInput
                    labelText={info_step_email_field_title}
                    placeholder={info_step_email_field_placeholder}
                    value={state.email.value}
                    valid={state.email.valid}
                    scrollTo={scrollTo}
                    errorMessage="Den indtastede email er ikke korrekt"
                    onChange={e => dispatch({
                        key: "email",
                        value: {
                            valid: e.target.value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
                            value: e.target.value
                        }
                    })}
                />
                <div
                    className="flex space-x-5"
                >
                    <div
                        className="w-1/3"
                    >
                        <CustomInput
                            placeholder={info_step_countrycode_field_placeholder}
                            labelText={info_step_countrycode_field_title}
                            value={state.countryCode.value}
                            scrollTo={scrollTo}
                            onChange={e => {
                                if (!Number.isInteger(+e.target.value.slice(1)) || e.target.value.length > 5) return;
                                dispatch({
                                    key: "countryCode",
                                    value: {
                                        valid: e.target.value.match(/\+/i) ? e.target.value.length > 2 : e.target.value.length > 1,
                                        value: e.target.value
                                    }
                                })
                            }}
                        />
                    </div>
                    <div
                        className="w-2/3"
                    >
                        <CustomInput
                            labelText={info_step_phone_field_title}
                            placeholder={info_step_phone_field_placeholder}
                            value={state.phone.value}
                            valid={state.phone.valid}
                            scrollTo={scrollTo}
                            errorMessage="Telefonnummer er ikke korrekt."
                            onChange={e => {
                                if (!Number.isInteger(+e.target.value)) return;
                                dispatch({
                                    key: "phone",
                                    value: {
                                        valid: String(e.target.value).length > 7,
                                        value: e.target.value
                                    }
                                })
                            }}
                        />
                    </div>
                </div>
                <div
                    className="flex space-x-5"
                >
                    <div
                        className="w-1/3"
                    >
                        <CustomInput
                            labelText={info_step_postal_field_title}
                            placeholder={info_step_postal_field_placeholder}
                            value={state.postalCode}
                            scrollTo={scrollTo}
                            onChange={e => {
                                if (!Number.isInteger(+e.target.value)) return;
                                if (+e.target.value > 9999) return;

                                const city = postal.find(e.target.value);
                                if (city) {
                                    dispatch({
                                        key: "city",
                                        value: city
                                    })
                                } else {
                                    dispatch({
                                        key: "city",
                                        value: ""
                                    })
                                }

                                dispatch({
                                    key: "postalCode",
                                    value: e.target.value
                                })
                            }}
                        />
                    </div>
                    <div
                        className="w-2/3"
                    >
                        <CustomInput
                            labelText={info_step_city_field_title}
                            placeholder={info_step_city_field_placeholder}
                            value={state.city}
                            scrollTo={scrollTo}
                            onChange={e => {
                                const postalCode = postal.find(e.target.value.trim())
                                if (postalCode) {
                                    dispatch({
                                        key: "postalCode",
                                        value: postalCode
                                    })
                                } else {
                                    dispatch({
                                        key: "postalCode",
                                        value: ""
                                    })
                                }

                                dispatch({
                                    key: "city",
                                    value: e.target.value
                                })
                            }}
                        />
                    </div>
                </div>
                <hr
                    className="border-skgGray"
                />
                <CustomInput
                    as={<textarea />}
                    labelText={info_step_comment_field_title}
                    rows={4}
                    value={state.comment}
                    scrollTo={scrollTo}
                    onChange={e => {
                        dispatch({
                            key: "comment",
                            value: e.target.value
                        })
                    }}
                />
                <div
                    className="space-x-3"
                >
                    <input
                        value={state.newsletter}
                        id="newsletter"
                        onChange={() => {
                            dispatch({
                                key: "newsletter",
                                value: !state.newsletter
                            })
                        }}
                        className="accent-skgBlue"
                        type="checkbox"
                    />
                    <label
                        htmlFor="newsletter"
                        className="text-sm font-light"
                    >
                        {
                            info_step_newsletter_title
                        }
                    </label>
                </div>
                <p
                    className="text-sm font-bold"
                >
                    {
                        info_step_newsletter_desc
                    }
                </p>
            </div>
            <div
                className="basis-full lg:basis-3/5 space-y-8 lg:pl-12"
            >
                {
                    state.carMake && !loadingCar
                        ? (
                            <div
                                className="space-y-2"
                            >
                                <div
                                    className="flex justify-between"
                                >
                                    <p
                                        className="text-xl"
                                    >
                                        Dit køretøj
                                    </p>
                                </div>
                                <div
                                    className="flex lg:justify-between items-center bg-white px-3 py-5 rounded-md shadow-md border-l-8 border-skgBlue divide-y lg:divide-x lg:divide-y-0 flex-wrap space-y-5"
                                >
                                    <div
                                        className="basis-full lg:basis-auto space-y-6 font-light"
                                    >
                                        <div
                                            className="space-y-1"
                                        >
                                            <p
                                                className="text-xs"
                                            >
                                                Reg.nr
                                            </p>
                                            <p
                                                className="text-sm"
                                            >
                                                {state.plate.value}
                                            </p>
                                        </div>
                                        <div
                                            className="space-y-1"
                                        >
                                            <p
                                                className="text-xs"
                                            >
                                                Bilmodel
                                            </p>
                                            <p
                                                className="text-sm"
                                            >
                                                {state.carMake + " " + state.carModel}
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        className="lg:pl-4 text-xs space-y-3 font-light basis-full lg:basis-auto pt-5 lg:pt-0"
                                    >
                                        <div
                                            className="flex justify-between space-x-6"
                                        >
                                            <p>
                                                Kilometerstand
                                            </p>
                                            <p>
                                                {
                                                    state.mileage ? state.mileage : "Ikke udfyldt"
                                                }
                                            </p>
                                        </div>
                                        <div
                                            className="flex justify-between space-x-6"
                                        >
                                            <p>
                                                Årgang
                                            </p>
                                            <p>
                                                {state.carYear || "Ikke udfyldt"}
                                            </p>
                                        </div>
                                        <div
                                            className="flex justify-between space-x-16"
                                        >
                                            <p>
                                                Type
                                            </p>
                                            <p>
                                                {state.carType || "Ikke udfyldt"}
                                            </p>
                                        </div>
                                        <div
                                            className="flex justify-between space-x-4"
                                        >
                                            <p>
                                                Farve
                                            </p>
                                            <p>
                                                {state.carColor || "Ikke udfyldt"}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                        : loadingCar
                            ? (
                                (
                                    <Skeleton
                                        className="h-80 md:h-44"
                                    />
                                )
                            )
                            : null
                }
                <div
                    className="space-y-2"
                >
                    <div
                        className="flex justify-between"
                    >
                        <p
                            className="text-xl"
                        >
                            Afdeling
                        </p>
                        {
                            !isExistingOffer && (
                                <p
                                    className="text-skgRed text-xs flex font-extralight cursor-pointer"
                                    onClick={() => goToByStepTitle("afdeling")}
                                >
                                    Skift afdeling
                                    <BsPencilFill
                                        className="ml-2"
                                    />
                                </p>
                            )
                        }
                    </div>
                    <div
                        className="flex justify-between items-center bg-white p-3 rounded-md shadow-md border-l-8 border-skgBlue"
                    >
                        <div
                            className="flex items-center space-x-4"
                        >
                            <div
                                className="w-8"
                            >
                                <img
                                    src={skgIcon}
                                />
                            </div>
                            <div
                                className=""
                            >
                                <div
                                    className="text-skgGray text-xs tracking-widest uppercase"
                                >
                                    skorstensgaard
                                </div>
                                <div
                                    className="font-light"
                                >
                                    {state.selectedShop.name}
                                </div>
                            </div>
                        </div>
                        <div
                            className="text-skgGray text-xs tracking-widest uppercase"
                        >
                            {state.selectedShop.address}
                        </div>
                    </div>
                </div>
                {
                    (String(pathname).match(/booking/i) || isExistingOffer) && (
                        <div
                            className="space-y-2"
                        >
                            <div
                                className="flex justify-between"
                            >
                                <p
                                    className="text-xl"
                                >
                                    Din booking
                                </p>
                                <p
                                    className="text-skgRed text-xs flex font-extralight cursor-pointer"
                                    onClick={() => goToByStepTitle("tid&dato")}
                                >
                                    Ændre din booking
                                    <BsPencilFill
                                        className="ml-2"
                                    />
                                </p>
                            </div>
                            <div
                                className="flex lg:justify-between items-center bg-white px-3 py-5 rounded-md shadow-md border-l-8 border-skgBlue divide-y lg:divide-x lg:divide-y-0 flex-wrap space-y-5"
                            >
                                <div
                                    className="basis-full lg:basis-auto space-y-6 font-light"
                                >
                                    <div
                                        className="space-y-1"
                                    >
                                        <p
                                            className="text-xs"
                                        >
                                            Skal indleveres senest
                                        </p>
                                        <span
                                            className="text-sm"
                                        >
                                            {
                                                state.selectedDate.locale("da").format("DD. MMMM YYYY")
                                            }
                                        </span>
                                        <span
                                            className="text-sm"
                                        >
                                            {
                                                state.timeOption === 2
                                                    ? (
                                                        " - Kl. 7.30"
                                                    )
                                                    : state.timeOption === 4
                                                        ? (
                                                            " - Udenfor åbningstid"
                                                        )
                                                        : (
                                                            " - kl. " + state.deliveryTime
                                                        )
                                            }
                                        </span>
                                    </div>
                                    <div
                                        className="space-y-1"
                                    >
                                        <p
                                            className="text-xs"
                                        >
                                            Ønsket afhentnings tidpunkt
                                        </p>
                                        <span
                                            className="text-sm"
                                        >
                                            {
                                                state.timeOption === 2 || state.timeOption === 1
                                                    ? (
                                                        state.selectedDate.locale("da").format("DD. MMMM YYYY")
                                                    )
                                                    : state.getCall
                                                        ? (
                                                            "Opringning"
                                                        )
                                                        : (
                                                            state.pickupDate.locale("da").format("DD. MMMM YYYY")
                                                        )
                                            }
                                        </span>
                                        <span
                                            className="text-sm"
                                        >
                                            {
                                                state.getCall
                                                    ? null
                                                    : state.timeOption === 1
                                                        ? (
                                                            " - Venter imens"
                                                        )
                                                        : (
                                                            state.timeOption === 2
                                                                ? (
                                                                    state.selectedDate.day() === 5
                                                                        ? " - Kl. 15.30"
                                                                        : " - Kl. 16.30"
                                                                )
                                                                : (
                                                                    " - Kl. " + state.pickupTime
                                                                )
                                                        )
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div
                                    className="lg:pl-4 text-xs space-y-3 font-light basis-full lg:basis-auto pt-5 lg:pt-0"
                                >
                                    <div
                                        className="flex justify-between space-x-6"
                                    >
                                        <p>
                                            Har bilen hele dagen
                                        </p>
                                        <p>
                                            {
                                                state.timeOption === 2 ? "Ja" : "Nej"
                                            }
                                        </p>
                                    </div>
                                    <div
                                        className="flex justify-between space-x-6"
                                    >
                                        <p>
                                            Lånebil
                                        </p>
                                        <p>
                                            {state.withCar ? "Ja" : "Nej"}
                                        </p>
                                    </div>
                                    <div
                                        className="flex justify-between space-x-16"
                                    >
                                        <p>
                                            Indlevere udenfor åbningstid
                                        </p>
                                        <p>
                                            {
                                                state.timeOption === 4 ? "Ja" : "Nej"
                                            }
                                        </p>
                                    </div>
                                    <div
                                        className="flex justify-between space-x-4"
                                    >
                                        <p>
                                            Venter i venterummet
                                        </p>
                                        <p>
                                            {
                                                state.timeOption === 1 ? "Ja" : "Nej"
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                {
                    !isExistingOffer && (
                        <div
                            className="space-y-2"
                        >
                            <div
                                className="flex justify-between"
                            >
                                <p
                                    className="text-xl"
                                >
                                    Dine valgte services og reparationer
                                </p>
                                <p
                                    className="text-skgRed text-xs flex font-extralight cursor-pointer"
                                    onClick={() => goToByStepTitle("reparationer")}
                                >
                                    Ændre dine valg
                                    <BsPencilFill
                                        className="ml-2"
                                    />
                                </p>
                            </div>
                            {
                                [...state.selectedRepairs, ...state.selectedUpsales]
                                    .map((repair, i) => {
                                        return (
                                            <div
                                                key={i}
                                                className="bg-white px-3 py-4 border-l-8 border-skgRed rounded-md shadow-md text-sm font-light"
                                            >
                                                {repair.name}
                                            </div>
                                        )
                                    })
                            }
                            {
                                state.repairComment
                                    ? (
                                        <div
                                            className="bg-white px-3 py-4 border-l-8 border-skgRed rounded-md shadow-md text-sm font-light"
                                        >
                                            {state.repairComment}
                                        </div>
                                    )
                                    : null
                            }
                        </div>
                    )
                }
                {
                    state.coupon
                        ? (
                            <div
                                className="space-y-2"
                            >
                                <div
                                    className="flex justify-between"
                                >
                                    <p
                                        className="text-xl"
                                    >
                                        Indløst rabatkode
                                    </p>

                                    <p
                                        className="text-skgRed text-xs flex font-extralight cursor-pointer"
                                        onClick={() => dispatch({ key: "coupon", value: "" })}
                                    >
                                        Slet kode
                                        <RiDeleteBin6Fill
                                            className="ml-2"
                                        />
                                    </p>
                                </div>
                                <div
                                    className="bg-white px-3 py-4 border-l-8 border-skgRed rounded-md shadow-md text-sm font-light"
                                >
                                    <span>
                                        {state.coupon}
                                    </span>
                                </div>
                            </div>
                        )
                        : (
                            <div
                                className="flex flex-row space-x-5"
                            >
                                <div
                                    className="flex-1"
                                >
                                    <CustomInput
                                        labelText={"Indtast rabatkode"}
                                        errorMessage={"Rabatkoden er ikke gyldig"}
                                        valid={couponValid}
                                        value={coupon}
                                        scrollTo={scrollTo}
                                        onChange={e => {
                                            setCoupon(e.target.value)
                                        }}
                                    />
                                </div>
                                <button
                                    className="bg-skgBlue rounded-md px-3 text-white disabled:opacity-30"
                                    style={{
                                        maxHeight: 56
                                    }}
                                    disabled={!coupon}
                                    onClick={() => {
                                        validateCoupon(coupon).then(isValid => {
                                            if (isValid) {
                                                setCouponValid(true);
                                                dispatch({
                                                    key: "coupon",
                                                    value: coupon
                                                })
                                                setCoupon("");
                                            }
                                        }).catch(err => {
                                            setCouponValid(false);
                                        })
                                    }}
                                >
                                    Indløs rabatkode
                                </button>
                            </div>
                        )
                }
            </div>
            <div
                className="basis-full"
            >
                <ConsentInfoBlock />
            </div>
        </div>
    )
}

export default InfoScreen;